import { useEffect, useRef } from "react";

// Hook die een modal koppelt aan de browser-history:
// - bij open: pushState zodat de back-button één step terug doet
// - bij back-button of swipe: triggert onClose
// - bij explicit close (× of Terug-knop): doet history.back() zodat de URL klopt
//
// Use:
//   const onClose = useModalHistory(() => setSelectedTown(null));
//   <button onClick={onClose}>×</button>
export function useModalHistory(rawClose) {
  const skipPopRef = useRef(false);
  const mountedRef = useRef(false);

  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;
    // Push een sentinel-state — back-button doet dan eerst dit popsen ipv navigeren
    window.history.pushState({ portugalModal: true }, "", window.location.href);

    const handler = () => {
      // History ging een step terug — modal moet sluiten
      skipPopRef.current = true;
      rawClose();
    };
    window.addEventListener("popstate", handler);

    return () => {
      window.removeEventListener("popstate", handler);
      // Als modal ge-unmounted wordt zonder dat popstate is gevuurd
      // (bv. via × of Terug-knop), doe alsnog history.back() — maar pas
      // skipPopRef toe zodat we niet dubbel sluiten.
      if (!skipPopRef.current && window.history.state?.portugalModal) {
        skipPopRef.current = true;
        window.history.back();
      }
    };
  }, [rawClose]);

  // De wrapped-close die UI-knoppen gebruiken
  return () => {
    if (skipPopRef.current) {
      rawClose();
      return;
    }
    // history.back() triggert popstate → onze handler → rawClose
    window.history.back();
  };
}
